import { render, staticRenderFns } from "./PaymentDetailForm.vue?vue&type=template&id=6ad47484&scoped=true&"
import script from "./PaymentDetailForm.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailForm.vue?vue&type=style&index=0&id=6ad47484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad47484",
  null
  
)

export default component.exports